import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as BrandActions from '../../../redux/actions/brands'
import { Label, Button, Container, Col, Row, Alert } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SidePopup from '../../SidePopup'
import BrandValidator from './BrandValidator'
import { userIsAuthorized } from '../../../routes/Authorizer/helpers'

const BrandEdit = (props) => {
  const brand = Object.values(props.brands).find((brand) => props.match.params.id === brand._id)
  const [confirmationDialog, setConfirmationDialog] = useState(false)
  const [errors, setErrors] = useState({})

  const handleSubmit = (values, { setSubmitting }) => {
    props
      .updateBrand(values)
      .then(() => hideModal())
      .catch((err) => setErrors(typeof err === 'object' ? err : { error: 'server-error' }))
      .finally(() => setSubmitting(false))
  }

  const hideModal = (e) => {
    if (e) e.preventDefault()
    props.history.goBack()
  }

  const deleteBrand = () => {
    props
      .deleteBrand(brand)
      .then(() => {
        const url = props.match.url
        const urlSlashes = url.split('/')

        // splice 3 last routes
        urlSlashes.splice(-3, 3)

        const newUrl = urlSlashes.join('/')
        props.history.push(`${newUrl}`)
      })
      .catch((err) => setErrors(typeof err === 'object' ? err : { error: 'server-error' }))
  }

  const toggleConfirmationDialog = () => setConfirmationDialog(!confirmationDialog)

  const { capabilities, user } = props

  let userCanManageBrand = userIsAuthorized({ capability: capabilities.brands, action: 'UPDATE' })

  if (user.role === 'brandManager') {
    user.brands.forEach((userBrand) => {
      if (userBrand.id === brand._id) {
        userCanManageBrand = true
      }
    })
  }

  return (
    <SidePopup
      onHide={hideModal}
      confirmationDialog={
        confirmationDialog && (
          <Container>
            <Row>
              <Col>
                <h3 className='mb-3'>{I18n.t('dashboard_youre-sure')}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button onClick={toggleConfirmationDialog} color='default'>
                  {I18n.t('dashboard_cancel')}
                </Button>
              </Col>
              <Col className='text-right'>
                <Button onClick={deleteBrand} color='danger'>
                  {I18n.t('dashboard_delete')}
                </Button>
              </Col>
            </Row>
          </Container>
        )
      }
      backButton
    >
      <Formik initialValues={{ ...brand }} validate={BrandValidator} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form>
            <Container className='px-0 pt-3'>
              <Row>
                <Col xs={12}>
                  <div className='section-title'>{I18n.t('brand.edit')}</div>
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='brand.name' className='required'>
                    {I18n.t('dashboard_name')}
                  </Label>
                  <Field id='brand.name' type='text' name='name' className='form-control' />
                  <ErrorMessage name='name' component='small' className='text-danger' />
                </Col>
              </Row>

              {Object.keys(errors).length > 0 && (
                <Row className='mt-3'>
                  {Object.keys(errors).map((e, i) => (
                    <Col key={i} xs={12}>
                      <Alert color='danger'>{I18n.t(`dashboard_errors_${errors[e]}`)}</Alert>
                    </Col>
                  ))}
                </Row>
              )}

              <Row className='no-gutters mt-3'>
                {userIsAuthorized({
                  capability: capabilities.brands,
                  action: 'DELETE',
                }) &&
                  !brand.isDefault && (
                  <Col>
                    <Button disabled={isSubmitting} onClick={toggleConfirmationDialog} color='danger'>
                      {I18n.t('dashboard_delete')}
                    </Button>
                  </Col>
                )}
                {userCanManageBrand && (
                  <Col className='text-right'>
                    <Button type='submit' disabled={isSubmitting} color='primary'>
                      {I18n.t('dashboard_save')}
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </SidePopup>
  )
}

const mapStateToProps = (state) => ({ brands: state.brands, user: state.user })

const mapDispatchToProps = (dispatch) => bindActionCreators(Object.assign({}, BrandActions), dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BrandEdit))
